export default __webpack_public_path__ + "static/media/BG-Red-0007.ddba8eb3.png";